import { useState, useEffect } from "react";
import Swal from "sweetalert2";

export default function UseCotizador() {
  const [brands, setBrands] = useState([]);
  const [versions, setVersions] = useState([]);
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    getModels();
  }, []);

  const getModels = async () => {
    try {
      const url = `https://store.lenken.com.ar/lenkenapi/cotizador/brands`;

      const response = await fetch(url);

      let data;

      if (response.status !== 200) {
        Swal.fire({
          text: "error al obtener los datos",
          icon: "error",
        });
      } else {
        data = await response.json();
        setBrands(data);
      }
    } catch {
      console.log("error al obtener los datos");
    }
  };

  const getVersions = async (marcaSeleccionada, modeloSeleccionado, anio) => {
    try {
      const url = `https://store.lenken.com.ar/lenkenapi/cotizador/brands/${marcaSeleccionada}/groups/${modeloSeleccionado}/year/${anio}`;

      const response = await fetch(url);

      let data;

      if (response.status !== 200) {
        Swal.fire({
          text: "error al obtener los datos",
          icon: "error",
        });
      } else {
        data = await response.json();

        const formatedData = [];

        for (let index = 0; index < data.length; index++) {
          formatedData.push({
            name: data[index].description,
            id: data[index].codia,
          });
        }

        setVersions(formatedData);
      }
    } catch {
      console.log("error al obtener los datos");
    }
  };

  const postSubmitData = async (submitData) => {
    setShowLoader(true);
    const response = await fetch(
      "https://store.lenken.com.ar/lenkenapi/cotizador/cotizar",
      {
        method: "POST",
        body: JSON.stringify(submitData),
        headers: {
          "Content-type": "application/json",
        },
      }
    );

    const result = await response.json();

    setShowLoader(false);

    if (response.status === 200) {
      Swal.fire({
        text: "Solicitud enviada correctamente, en breve recibirás tu cotización",
        icon: "success",
        type: "success",
      }).then(function () {
        window.location = "https://store.lenken.com.ar/"; //cambiar redirect a home de cada empresa
      });
    } else if (response.status === 403) {
      Swal.fire({
        text: "Ha superado el número de consultas permitidas.",
        icon: "info",
      });
    } else {
      Swal.fire({
        text: "error al obtener los datos",
        icon: "error",
      });
    }

    console.log(result);
  };

  return {
    brands,
    getVersions,
    versions,
    setVersions,
    postSubmitData,
    showLoader,
  };
}
